// extracted by mini-css-extract-plugin
export default {"login":"LandingPageCarousel_login__OAFih"};